import { getFileTypeFromFileName } from '@office-start/file-utility';
import { cancelUploadSession } from '@office-start/graph-service';
import { UploadSessionState, } from '@office-start/upload-types';
import { appendQuery } from '@office-start/url-parser-utility';
import { advanceState } from './advanceState';
export function uploadLargeFile(graphXhrOptions, uploadSession, uploadObservable, uploadConfig) {
    uploadSession.state = UploadSessionState.Started;
    uploadObservable.next(uploadSession);
    return uploadToOneDrive(graphXhrOptions, uploadSession, uploadConfig).then(function (url) {
        uploadSession.result = url;
        uploadSession.state = UploadSessionState.Completed;
        uploadObservable.next(uploadSession);
    }, function (_error) {
        // uploadSession.error = getUploadSessionError(error, uploadSession, uploadObservable); // TODO
        uploadSession.state = UploadSessionState.Failed;
        uploadObservable.next(uploadSession);
    });
}
function uploadToOneDrive(graphXhrOptions, uploadSession, uploadConfig) {
    // OneDrive API requires multi-stage upload for files over 4MB
    return uploadLarge(graphXhrOptions, uploadSession, uploadConfig).then(function (item) {
        var fileUrlModel = {};
        if (item.webDavUrl) {
            fileUrlModel.canonicalUrl = item.webDavUrl;
        }
        var webUrl = item.webUrl;
        var type = getFileTypeFromFileName(uploadSession.file.name);
        if (type && uploadConfig.editableFileTypes.has(type)) {
            // Launch editable files in edit mode
            var editQueryParam = 'action=edit';
            webUrl = webUrl.replace(new RegExp('([?&])action[^&]*'), '$1' + editQueryParam);
            if (webUrl.lastIndexOf(editQueryParam) === -1) {
                webUrl = appendQuery(webUrl, editQueryParam);
            }
        }
        fileUrlModel.webUrl = webUrl;
        return fileUrlModel;
    });
}
function uploadLarge(graphXhrOptions, uploadSession, uploadConfig) {
    return uploadState(graphXhrOptions, uploadSession, {}, uploadConfig);
}
// The below url doesn't work for me anymore
// This method was adapted from the OneDrive codebase: https://onedrive.visualstudio.com/OneDriveWeb/_git/odsp-next?path=%2Fsrc%2Flocal%2FdataSources%2Fupload%2Fvroom%2FVroomUploader.ts&version=GBmaster&_a=contents
function uploadState(graphXhrOptions, session, state, uploadConfig) {
    var sessionUrl = state.sessionUrl, item = state.item, error = state.error;
    session.sessionUrl = sessionUrl;
    return new Promise(function (resolve, reject) {
        if (item) {
            // Success state.
            resolve(item);
        }
        else if (error) {
            if (!sessionUrl) {
                // The session was never created, so no need to destroy it
                reject(error);
            }
            else {
                // Destroy the started upload session
                cancelUploadSession(graphXhrOptions, sessionUrl, session.sessionId)
                    .catch(function () {
                    /* Ignore error. */
                })
                    .then(function () { return reject(error); });
            }
        }
        else {
            advanceState(graphXhrOptions, session, state, session.cancellationToken, uploadConfig).then(function (nextState) {
                // Cycle back through the machine.
                uploadState(graphXhrOptions, session, nextState, uploadConfig).then(resolve, reject);
            }, reject);
        }
    });
}
//# sourceMappingURL=uploadLargeFile.js.map